var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 30.625C25.2487 30.625 31.125 24.7487 31.125 17.5C31.125 10.2513 25.2487 4.375 18 4.375C10.7513 4.375 4.875 10.2513 4.875 17.5C4.875 24.7487 10.7513 30.625 18 30.625ZM23.36 15.6588C23.9539 15.1148 23.9944 14.1923 23.4505 13.5984C22.9065 13.0044 21.984 12.9639 21.39 13.5079L16.0058 18.4391L14.61 17.1608C14.016 16.6168 13.0935 16.6573 12.5496 17.2513C12.0056 17.8452 12.0461 18.7677 12.64 19.3117L15.0208 21.4921C15.5782 22.0026 16.4333 22.0026 16.9907 21.4921L23.36 15.6588Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.d23cd8a3304a3b1254a102bf0d2357d4.svg";
export { ForwardRef as ReactComponent };